const footer = {
  copyright: "Copyright © 2022 HitPaw. Co., Ltd. Все права защищены.",
};

export default footer;
